import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationAdminFilterKey, NotificationType, ZoudashUtils } from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  DataHeaderFilter,
  FilterChangedDetection,
  FilterRecord,
} from '@workspace/ng-aura';
import { NotificationColumnKey } from '../abstract-notifications-data-table.component';

export interface NotificationFilterModel {
  type: string | string[] | null;
  read: string | string[] | null;
}

@Component({
  selector: 'core-notifications-data-table-filter',
  templateUrl: './notifications-data-table-filter.component.html',
  imports: [FormField, MatFormFieldModule, MatInputModule, MatListModule, MatSlideToggleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsDataTableFilterCoreComponent extends AbstractSignalFormComponent<
  Partial<Record<NotificationAdminFilterKey, string | string[]>>,
  NotificationFilterModel
> {
  currentFilterView = input<string | null>(null);
  filters = input.required<DataHeaderFilter<NotificationColumnKey>[]>();
  filterChanged = output<FilterChangedDetection>();
  notificationTypeValues = Object.values(NotificationType);
  readValues = ['true', 'false'];
  notificationAdminFilterKey = NotificationAdminFilterKey;

  override model: WritableSignal<NotificationFilterModel> = signal<NotificationFilterModel>({
    type: null,
    read: null,
  });

  override formTree = form(this.model);

  override emitDto(newDto: Partial<Record<NotificationAdminFilterKey, string | string[]>>): void {
    this.filterChanged.emit({
      filter: newDto as FilterRecord,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(
    dto: Partial<Record<NotificationAdminFilterKey, string | string[]>>,
  ): NotificationFilterModel {
    return {
      type: dto?.[NotificationAdminFilterKey.Type] ?? null,
      read: dto?.[NotificationAdminFilterKey.Read] ?? null,
    };
  }

  protected override buildDtoFromModel(
    model: NotificationFilterModel,
  ): Partial<Record<NotificationAdminFilterKey, string | string[]>> {
    const dto: Partial<Record<NotificationAdminFilterKey, string | string[]>> = {
      type: model.type ?? undefined,
      read: model.read ?? undefined,
    };
    return Object.fromEntries(Object.entries(dto).filter(([, v]) => v != null)) as Partial<
      Record<NotificationAdminFilterKey, string | string[]>
    >;
  }
}
